import { AuthProvider } from './../auth/auth';
import { HttpClient } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV } from '../../environments/environment';
import { Apollo } from 'apollo-angular';
import { COMPANIES_QUERY } from './queries';
import { StorageProvider } from '../utils/storage';

@Injectable()
export class ProvidersProvider {
  private providers: Provider[]; // PROVIDERS
  private companies: any;
  constructor(
    public http: HttpClient, 
    private authProvider: AuthProvider, 
    private apollo: Apollo,
    private storageProvider: StorageProvider
  ) {}

  getProviders() {
    return Observable.create(observer => {
      observer.next(this.authProvider.userData.data.providers);
    });
  }

  getProvidersB() {
    return Observable.create(observer => {
      if (this.providers) {
        // return cached result
        observer.next(this.providers);
      } else {
        this.authProvider.getOptions().subscribe(options => {
          this.http.get(ENV.api + '/api/providers', options).subscribe(
            providersResult => {
              observer.next(providersResult);
            },
            error => {
              observer.error(error);
            }
          );
        });
      }
    });
  }

  getCompaniesQL(
    params: {
      lookAfter: any;
      lookBefore: any;
      limit: number;
      fullText: string;
      filters?:any;
    } = {
      lookAfter: null,
      lookBefore: null,
      limit: 100,
      fullText: null
    }
  ) {

      return Observable.create(obs => {
        if(this.companies){
          obs.next(this.companies);
          obs.complete();
        }

        else {
          if(!params.filters) params.filters = {tags: { _in: ["geyser-installer"] }};

          const hasQueryBeenCalledBefore = this.storageProvider.hasQueryBeenCalledBefore({ getCompaniesQL: { ...params } });
          if (hasQueryBeenCalledBefore || hasQueryBeenCalledBefore == "notFound") { 
            obs.next(hasQueryBeenCalledBefore !== "notFound" ? hasQueryBeenCalledBefore : null);

          } else {
            this.apollo
              .query<any>({
                query: COMPANIES_QUERY,
                variables: params
              })
              .subscribe(
                r => {
                  const result = r.data.groupsCollection.items;
                  this.companies = result;
                  this.storageProvider.setCachedQueryData({ getCompaniesQL: { ...params } }, result);
                  obs.next(result);
                },
                e => {
                  obs.error(e);
                }
              );
          }
        }
    });
  }

  getCachedCompanyById(id: string){
    return this.companies?.find(company => company.snn === id);
  }
}



// WEBPACK FOOTER //
// ./src/providers/providers/providers.ts